// extracted by mini-css-extract-plugin
export var statItem = "_jh-1";
export var statsRow = "_jh-0";